module.exports = __webpack_public_path__ + "img/service1.efe647c0.png";